/**
 * Один источник каталога сфер на всё приложение.
 *
 * Подписка на таблицу своих сфер живёт здесь, а не в карточках: карточек на
 * экране десятки, и каждая спрашивала бы у базы одно и то же.
 */

import { type ReactNode, useMemo } from 'react';

import { buildCatalog } from '../model/catalog';
import { SphereCatalogContext, useCustomSpheres } from '../model/use-spheres';

export function SphereCatalogProvider({ children }: { children: ReactNode }) {
  const custom = useCustomSpheres();
  const catalog = useMemo(() => buildCatalog(custom ?? []), [custom]);

  return <SphereCatalogContext value={catalog}>{children}</SphereCatalogContext>;
}
